import type { Theme } from '@mui/material';
import {
  RICH_TEXT_LARGE_HEADING_LEVEL,
  RICH_TEXT_LARGE_SIZE,
  RICH_TEXT_MEDIUM_HEADING_LEVEL,
  RICH_TEXT_MEDIUM_SIZE,
  RICH_TEXT_SIZE_ATTRIBUTE,
  RICH_TEXT_SIZE_TAG,
  RICH_TEXT_UNDERLINE_TAG,
  RICH_TEXT_UNSUPPORTED_LARGE_HEADING_LEVELS,
  RICH_TEXT_UNSUPPORTED_MEDIUM_HEADING_LEVELS,
} from './richText.constants';

const toHeadingSelector = (levels: number[]) => levels.map((level) => `& h${level}`).join(', ');

export const getRichTextContentStyles = (theme: Theme) => ({
  [toHeadingSelector([
    RICH_TEXT_LARGE_HEADING_LEVEL,
    ...RICH_TEXT_UNSUPPORTED_LARGE_HEADING_LEVELS,
  ])]: {
    fontSize: theme.typography.h4.fontSize,
    margin: theme.spacing(1, 0, 0.5),
  },
  [toHeadingSelector([
    RICH_TEXT_MEDIUM_HEADING_LEVEL,
    ...RICH_TEXT_UNSUPPORTED_MEDIUM_HEADING_LEVELS,
  ])]: {
    fontSize: theme.typography.h6.fontSize,
    margin: theme.spacing(1, 0, 0.5),
  },
  [`& ${RICH_TEXT_UNDERLINE_TAG}`]: {
    textDecoration: 'underline',
    textDecorationThickness: '1px',
    textUnderlineOffset: '2px',
  },
  [`& ${RICH_TEXT_SIZE_TAG}[${RICH_TEXT_SIZE_ATTRIBUTE}="${RICH_TEXT_LARGE_SIZE}"]`]: {
    fontSize: theme.typography.h4.fontSize,
  },
  [`& ${RICH_TEXT_SIZE_TAG}[${RICH_TEXT_SIZE_ATTRIBUTE}="${RICH_TEXT_MEDIUM_SIZE}"]`]: {
    fontSize: theme.typography.h6.fontSize,
  },
  '& > :first-of-type': { marginTop: 0 },
});
